type ApiHosts = {
    authorization: string,
    project: string,
    publicAssets: string,
    resources: string
};

let apiHosts: ApiHosts = {
    authorization: 'https://gift-api-projects-authorization.azurewebsites.net',
    project: 'https://gift-api-projects.azurewebsites.net',
    publicAssets: 'https://gift-api-assets-public.azurewebsites.net',
    resources: 'https://gift-api-resources.azurewebsites.net'
};

// The `if` branches below are interpreted at build time. The dev and staging URLs are
// not included in the production build.

if (process.env.REACT_APP_ENV === 'staging') {
    apiHosts = {
        authorization: 'https://gift-api-projects-authorization-staging.azurewebsites.net',
        project: 'https://gift-api-projects-staging.azurewebsites.net',
        publicAssets: 'https://gift-api-assets-public-staging.azurewebsites.net',
        resources: 'https://gift-api-resources-staging.azurewebsites.net'
    };
}

if (process.env.NODE_ENV === 'development' || process.env.REACT_APP_ENV === 'development') {
    apiHosts = {
        authorization: 'https://api-projects-authorization.local:18004',
        project: 'https://api-project.local:18001',
        publicAssets: 'https://api-assets-public.local:18002',
        resources: 'https://api-resources.local:18009'
    };
}

export const urls = {
    requestNewToken: `${apiHosts.authorization}/tokens/new`,
    requestExistingToken: `${apiHosts.authorization}/tokens/existing`,
    pushProject: `${apiHosts.project}/projects/push`,
    listPublicAssets: `${apiHosts.publicAssets}/assets`,
    loadPublicAsset: (id: string, locale: string) => `${apiHosts.publicAssets}/assets/${id}/${locale}`,
    loadCollection: (id: string) => `${apiHosts.publicAssets}/collections/${id}`,
    loadResource: (id: string) => `${apiHosts.resources}/resources/${id}`
};